'use client';

import { useId, useState } from 'react';
import dynamic from 'next/dynamic';
import { Mountain, ChevronDown } from 'lucide-react';
import type { MountainVisualiserForecast } from '@/lib/conditions/visualiser/mountain-forecast';
import type { SnowSceneSport } from '@/lib/conditions/visualiser/mountain-diorama';

const MountainVisualiser = dynamic(() => import('@/app/tools/conditions-visualiser/MountainVisualiser').then((module) => module.MountainVisualiser), {
  ssr: false,
  loading: () => <div role="status" className="flex aspect-video items-center justify-center rounded-2xl bg-navy/10 text-sm text-navy">Opening the mountain window…</div>,
});

/** The forecast is already in the page payload. Opening the scene makes no data read. */
export function ExpandableMountainScene({ forecast, sport }: { forecast: MountainVisualiserForecast; sport: SnowSceneSport }) {
  const [expanded, setExpanded] = useState(false);
  const panelId = useId();
  return <div className="mt-5">
    <button type="button" aria-expanded={expanded} aria-controls={expanded ? panelId : undefined}
      onClick={() => setExpanded((value) => !value)}
      className="flex min-h-12 w-full items-center gap-3 rounded-2xl border border-border-light bg-warm-bg px-4 py-3 text-left text-[14px] font-semibold text-navy focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal">
      <Mountain size={24} aria-hidden="true" /><span>Watch the mountain with Colin</span>
      <ChevronDown size={17} aria-hidden="true" className={`ml-auto shrink-0 transition-transform ${expanded ? 'rotate-180' : ''}`} />
    </button>
    {expanded && <div id={panelId} className="mt-3"><MountainVisualiser initialForecast={forecast} initialSport={sport} embedded /></div>}
  </div>;
}
